import { FC, useLayoutEffect, useRef } from 'react';

/**
 * The static app shell from index.html, captured before React's first render replaces it.
 */
const staticSkeleton = document.getElementById('app-skeleton')?.cloneNode(true);

/**
 * Renders the same app-shell skeleton that index.html paints before the bundle loads, so loading
 * states during app start-up continue it seamlessly rather than flashing blank. Renders nothing
 * where there is no static skeleton (e.g. in tests).
 */
export const AppSkeleton: FC = () => {
    const containerRef = useRef<HTMLDivElement>(null);

    useLayoutEffect(() => {
        const container = containerRef.current;

        if (!container || !staticSkeleton) {
            return;
        }

        container.replaceChildren(staticSkeleton.cloneNode(true));
    }, []);

    return <div ref={containerRef} />;
};
